<div class="w-full bg-white">
  <div class="w-full m-auto">
    <div *ngIf="!isCommissionType">
      <section class="text-left mb-6 mt-6">
        <!-- <i class="fa-solid fa-circle-check text-green-600 text-3xl mb-4"></i> -->
        <h1>{{ 'bankTransfer:title' | translate }}</h1>
      </section>
      <ng-content></ng-content>
      <section class="mb-8">
        <p class="mb-2 text-sm">
          {{ 'bankTransfer:subtitle1' | translate }}
        </p>
      </section>

      <section class="p-6 mb-10 border-gray-300 border-solid border rounded-lg">
        <p class="mb-2 text-sm text-gray-400 font-light">
          {{ 'bankTransfer:amountToPayTitle' | translate }}
        </p>
        <p class="mb-2 text-xl font-bold">
          <ew-format-currency
            [amount]="convertedAmount ?? ''"
            [currency]="convertedCurrency ?? ''"></ew-format-currency>
        </p>
        <p class="mb-5 text-sm text-gray-400 font-light" *ngIf="expiryDate">
          {{ 'bankTransfer:guaranteedRate' | translate }}
          {{ getMonthName(expiryDate.getMonth()) }} {{ expiryDate.getDate() }},
          {{ expiryDate.getFullYear() }}
        </p>
        <p class="mb-2 text-sm text-gray-400 font-light">
          {{
            type === 'Invoice'
              ? ('bankTransfer:amountToBeCredited' | translate)
              : ('bankTransfer:amountToReceiveTitle' | translate)
          }}
        </p>
        <p class="text-xl font-bold">
          <ew-format-currency
            [amount]="paymentAmount"
            [currency]="paymentCurrency"></ew-format-currency>
        </p>
      </section>
    </div>

    <!-- Payment Instructions Section -->
    <section
      class="mb-10 p-6 border-gray-300 border-solid border rounded-lg"
      *ngIf="bankTransferData">
      <h2
        *ngIf="!isCommissionType"
        class="mb-6"
      >
        {{ 'bankTransfer:accountInformationTitle' | translate }}
      </h2>
      <div id="bank-transfer-information">
        <table class="bank-details">
          <tbody>
            <tr
              *ngFor="let row of bankTransferDetails; let i = index"
              class="break-all">
              <td *ngIf="row.key !== 'TransferCurrency'">
                {{ 'bankTransfer:' + row.key | translate }}
              </td>
              <td
                class="cursor-pointer"
                (mouseenter)="hoveredIndex = i"
                (mouseleave)="hoveredIndex = null"
                role="button"
                tabindex="0"
                (keydown.enter)="copyToClipboard(row.value, tooltip)"
                (click)="copyToClipboard(row.value, tooltip)"
                matTooltip="{{ tooltipMessage | translate }}"
                [matTooltipPosition]="'above'"
                #tooltip="matTooltip">
                <i
                  class="fa-regular fa-copy mr-2"
                  *ngIf="hoveredIndex === i"></i>
              </td>
              <td
                *ngIf="row.key !== 'TransferCurrency'"
                class="cursor-pointer"
                (mouseenter)="hoveredIndex = i"
                (mouseleave)="hoveredIndex = null"
                (click)="copyToClipboard(row.value, tooltip)"
                matTooltip="{{ tooltipMessage | translate }}"
                [matTooltipPosition]="'above'"
                #tooltip="matTooltip">
                <span>{{ row.value }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- External Payment Section -->
    <section
      class="mb-10 p-6 border-gray-300 border-solid border rounded-lg"
      *ngIf="isExternalPayment() && !isExpired">
      <h2 class="mb-8">
        {{ 'externalBankTransfer:instructionsTitle' | translate }}
      </h2>
      <p class="mb-6">
        {{ 'externalBankTransfer:instructionsText' | translate }}
      </p>
      <div class="text-center">
        <a
          [href]="externalPaymentUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-block bg-blue-600 text-white py-2 px-4 rounded-lg">
          <i class="fa-solid fa-arrow-up-right-from-square mr-2"></i>
          {{ 'externalBankTransfer:instructionsButtonText' | translate }}
        </a>
      </div>
    </section>
  </div>
</div>
